module.exports = __webpack_public_path__ + "img/2-32-7.c2375342.png";